import { render, staticRenderFns } from "./My.vue?vue&type=template&id=ef42b1d0&scoped=true&"
import script from "./My.vue?vue&type=script&lang=js&"
export * from "./My.vue?vue&type=script&lang=js&"
import style0 from "./My.vue?vue&type=style&index=0&id=ef42b1d0&lang=scss&scoped=true&"
import style1 from "./My.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef42b1d0",
  null
  
)

export default component.exports